import { MarketingNavigation } from "../components/MarketingNavigation"
import { MarketingFaqSection } from "../components/MarketingFaqSection"
import { MarketingBackgroundVector } from "../components/MarketingBackgroundVector"
import { supportFaqData, supportFeatures, discordBenefits } from "../data/supportContent"
import "../marketing.css"

export function SupportMarketingPage() {
  return (
    <div className="mk-page">
      <div className="mk-page-gradient">
        <MarketingBackgroundVector />
        <MarketingNavigation activePage="Support" />

        {/* Hero / Header */}
        <div className="mk-header mk-header-transparent">
          <div className="mk-header-content">
            <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {/* Large message icon */}
              <div className="mk-support-hero-icon">
                <img src="/marketing/go/icons/message.svg" alt="" />
              </div>

              <h1 className="mk-title">
                Support for <span className="mk-title-accent">To To-Do</span>
              </h1>
              <p className="mk-subtitle">
                To To-Do is a community-driven productivity app built with a bold vision: to create the
                world's best productivity app, simplifying and enhancing people's quality of life.
              </p>

              <div style={{ marginTop: 40, marginBottom: 100 }}>
                <a
                  href="https://discord.gg/mqcPWsQRgS"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mk-cta mk-cta-primary"
                  style={{ gap: 10, maxWidth: 350 }}
                >
                  <img
                    src="/marketing/go/icons/community.svg"
                    alt=""
                    style={{ width: 20, height: 20, filter: "brightness(0) invert(1)" }}
                  />
                  Join our Discord community
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Community Approach */}
      <div className="mk-section">
        <div className="mk-container">
          <div className="mk-support-content-grid">
            <img
              src="/marketing/images/community-approach.png"
              alt="Community approach"
              className="mk-support-content-img"
            />
            <div>
              <h2 className="mk-title" style={{ textAlign: "left" }}>
                Our community <span className="mk-title-accent">approach</span>
              </h2>
              <p style={{ marginTop: 16 }}>
                Inspired by world-leading productivity tools, we've crafted a seamless experience
                across web, iOS, and Android, with real-time collaboration and AI-powered task
                assistance—all shaped by your feedback.
              </p>
              <p style={{ marginTop: 16 }}>
                Our support lives on Discord, where our team and community come together to help.
                Whether you have a question, need assistance, or want to share ideas, we're here
                for you.
              </p>
              <p style={{ marginTop: 16 }}>
                We're a small, passionate team, and our community drives us toward our vision. No
                formal support tickets—just real conversations with people who care.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Why choose community support */}
      <div className="mk-section">
        <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <span className="mk-chip">
            <span className="mk-chip-icon">
              <img src="/marketing/go/icons/message.svg" alt="" />
            </span>
            Community
          </span>
          <h2 className="mk-title">
            Why choose <span className="mk-title-accent">community support?</span>
          </h2>

          <div className="mk-features-grid">
            {supportFeatures.map((f) => (
              <div key={f.title} className="mk-feature-card">
                <div className="mk-feature-icon">
                  <img src={f.iconSrc} alt="" />
                </div>
                <div>
                  <h3>{f.title}</h3>
                  <p>{f.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Join Discord */}
      <div className="mk-section">
        <div className="mk-container">
          <div className="mk-support-discord-grid">
            <div>
              <h2 className="mk-title" style={{ textAlign: "left" }}>
                Join our <span className="mk-title-accent">Discord community?</span>
              </h2>
              <div style={{ marginTop: 8, marginBottom: 32 }}>
                <p>
                  Join our Discord to get help, share feedback, or simply connect with like-minded
                  individuals. Let's build the ultimate productivity app together!
                </p>
                <p style={{ marginTop: 16 }}>
                  Our community is active and waiting to help you. The To To-Do team regularly monitors
                  discussions and responds to questions.
                </p>
              </div>
              <a
                href="https://discord.gg/mqcPWsQRgS"
                target="_blank"
                rel="noopener noreferrer"
                className="mk-cta mk-cta-primary"
                style={{ maxWidth: 300, gap: 10 }}
              >
                <img
                  src="/marketing/go/icons/community.svg"
                  alt=""
                  style={{ width: 20, height: 20, filter: "brightness(0) invert(1)" }}
                />
                Join Discord
              </a>
            </div>

            <div className="mk-discord-benefits">
              {discordBenefits.map((benefit, i) => (
                <div key={i} className="mk-discord-benefit-item">
                  <span className="mk-discord-check">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                  </span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <MarketingFaqSection
        faqData={supportFaqData}
        chipTitle="Questions"
        mainTitle="Frequently asked questions"
      />
    </div>
  )
}
